import Vue from 'vue'
import sendGaEvent from '@/utvStore/components/VideoPlayer/utils/sendGaEvent'

const gaEvent = {
  bind(el, binding) {
    if (!binding.value.event) return

    if (binding.value.event === 'click') {
      el.addEventListener('click', () => {
        // ga('send', 'event', binding.value.category, 'click', binding.value.label, 1, { 'nonInteraction': 1 });
        sendGaEvent({ event: 'click', category: binding.value.category, label: binding.value.label, trackingCode: 'UA-100415034-1' })
        sendGaEvent({ event: 'click', category: binding.value.category, label: binding.value.label, trackingCode: 'UA-100415034-5' })
        console.log('ga click event', `event:${binding.value.event}`, `category:${binding.value.category}`, `label:${binding.value.label}`)
      })
    }
  },
  update(el, binding) {
    if (!binding.value.event) return
    if (binding.value.event === 'impression') {
      // ga('send', 'event', binding.value.category, 'impression', binding.value.label, 1, { 'nonInteraction': 1 });
      sendGaEvent({ event: 'impression', category: binding.value.category, label: binding.value.label, trackingCode: 'UA-100415034-1' })
      sendGaEvent({ event: 'impression', category: binding.value.category, label: binding.value.label, trackingCode: 'UA-100415034-5' })
      console.log(
        'ga impression event',
        `event:${binding.value.event}`,
        `category:${binding.value.category}`,
        `label:${binding.value.label}`
      )
    }
  }
}

Vue.directive('gaEvent', gaEvent)



// WEBPACK FOOTER //
// ./resources/assets/js/directive/gaEvent.js